import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TemplatesDataProvider {
	templates: any = {};

	constructor(private http: HttpClient) {}

	private getLink(templateType, id): string {
		let url = '';

		switch (templateType) {
			case 'all':
				url = '/protected/rest/email_templates/get';
				break;

			case 'contract_preview':
				url = '/protected/rest/job/contract/sources';
				break;

			case 'questionnaire_preview':
				url = '/protected/rest/job/questionnaire/sources';
				break;

			case 'general_preview':
				url = '/protected/rest/email_templates/get/general';
				break;

			case 'contract_full':
				url = `/protected/rest/contracts/get/${id}`;
				break;

			case 'full_template':
				url = `/protected/rest/settings/email_template/get/${id}?forSend=true`;
				break;

			case 'template_without_signature':
				url = `/protected/rest/settings/email_template/get/${id}?forSend=false`;
				break;

			case 'email_signature':
				url = '/protected/rest/email_templates/signature/get';
				break;
			default:
				break;
		}

		return url;
	}

	setTemplatesInStorage(data): void {
		this.templates = JSON.parse(JSON.stringify(data));
	}

	getTemplatesFromStorage(): Observable<any> {
		return JSON.parse(JSON.stringify(this.templates));
	}

	getTemplates(templateType, id: number = null): Observable<any> {
		const url = this.getLink(templateType, id);
		return this.http.get(url);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/data-services/templates-data-service/templates.data.service.ts